import React from 'react';
import ItemGrid from '../common/ItemGrid';
import ItemCard from '../common/ItemCard';
import ItemListView from '../common/ItemListView';
import { learningPathService } from '../../services/api';
import '../Course/CourseGrid.css';

const LPathGrid = () => {
  const fetchLPaths = async (page, limit, searchTerm, sortOrder, authorId, userId, audienceType) => {
    return await learningPathService.getLPaths(page, limit, searchTerm, sortOrder, authorId, userId,  audienceType);
  };

  return (
    <ItemGrid
      title="All Learning Paths"
      description=""
      itemType="learningPath"
      fetchItems={fetchLPaths}
      ItemCardComponent={(props) => <ItemCard {...props} itemType="learningPath" />}
      ItemListComponent={(props) => <ItemListView {...props} itemType="learningPath" />}
      createPermission="create_learning_path"
      createPath="/learning_path/form"
      authorFilterEnabled={false}
      onClearFilters={() => window.dispatchEvent(new CustomEvent('resetItemGrid'))}
    />
  );
};

export default LPathGrid;